const SIZES = {
  FIELD: 55,
  VARIABLE: 45,
};

export default SIZES;
